<template lang="pug">
  NotFound(
    v-if="ovNotFound"
    entityType="ov"
    :entityId="$route.params.ov_id"
  )
  .loader(v-else-if="loading")
    b-spinner(label='Cargando...' variant="danger")
  div(v-else)
    div.container
      b-row
        b-col.title-header(cols='6').d-flex.justify-content-flex-start
          b-icon.back-arrow.h3.mb-4.cursor-pointer(
            icon="arrow-left-square-fill"
            variant=""
            @click="$router.go(-1)"
          )
          h1.pl-2(id="title-ot").title Detalle OdV {{ $route.params.ov_id }}
      b-row
        b-col.d-flex.justify-content-start
          b-breadcrumb( :items="breadcrumbs" )
    b-container
      b-row
        //- Main Column (70% approx)
        b-col(cols="12" xl="8")

          b-card(rounded-4 class="mb-3 border-0 shadow-sm card-ov-detail")
            //- Header and Actions (ALL WIDTHS)
            div
              b-row.ov-header-info.mb-3
                b-col
                  span.head-card OV {{ $route.params.ov_id }}
                  span.separator //
                  span.head-card OT 
                    router-link.ot-link(
                      v-if="ovDetail.ot"
                      :to="{ name: 'Orden de Trabajo', params: { order_id: ovDetail.ot } }"
                      target="_blank"
                    ) {{ ovDetail.ot }}
                    span(v-else) -
                  span.separator //
                  span.head-card RMA: {{ ovDetail.rma || '-' }}
              b-row.title-buttons.pb-4
                b-col.state-head
                  span.state-title Estado Actual
                  span.ov-status.state-badge(id="estado-actual" :style="getOvColor()") {{ ovDetail.estado }}
                b-col.action-print-buttons
                  b-button.printer-btn.mr-2(variant="outline" v-if="ovDetail.cotizacion_pdf" :disabled="loadingPrint" @click="printQuotation")
                    b-icon(icon="file-earmark-arrow-down-fill" )
                    span.ml-2 Descargar Cotización
                    b-spinner(v-if="loadingPrint" small)
                  OVActionsIndex(
                    :ovId="+($route.params.ov_id)",
                    :dataOv="ovDetail"
                    @reloadAll="fetchData"
                  ) Acciones
            //- Banner: OV rechazada con sucesora
            b-row.my-2(v-if="ovDetail.nueva_ov_id")
              b-col
                .ov-link-banner.ov-link-banner--rechazada
                  .ov-link-banner__content
                    b-icon.ov-link-banner__icon(icon="exclamation-circle-fill")
                    div
                      div Esta Oportunidad de Venta fue #[strong Rechazada].
                      div Ha sido reemplazada por una nueva versión
                  router-link.ov-link-banner__link(
                    :to="{ path: `/oportunidad-venta/${ovDetail.nueva_ov_id}` }"
                  )
                    | Ir a la nueva: OV{{ ovDetail.nueva_ov_id }}
                    b-icon.ml-1(icon="arrow-up-right")

            //- Banner: OV creada desde una rechazada
            b-row.my-2(v-if="ovDetail.ov_rechazada_id && !ovDetail.nueva_ov_id")
              b-col
                .ov-link-banner.ov-link-banner--origen
                  .ov-link-banner__content
                    b-icon.ov-link-banner__icon(icon="info-circle-fill")
                    span Esta Oportunidad de Venta proviene de una versión Rechazada.
                  router-link.ov-link-banner__link(
                    :to="{ path: `/oportunidad-venta/${ovDetail.ov_rechazada_id}` }"
                  )
                    | Revisar OV Rechazada: OV{{ ovDetail.ov_rechazada_id }}
                    b-icon.ml-1(icon="arrow-up-right")


            OVDetailClienteData(:ov="ovDetail" @saved="fetchData")
            OVDetailRepuestosData(:ov="ovDetail")
            OVDetailCotizacionYBoletas(:ov="ovDetail")
            TabOVRepuestos(:ov="ovDetail")
        
        //- Sidebar Column (30% approx)
        b-col(cols="12" xl="4" class="mt-4 mt-xl-0")
          OVDetailBoletas(:ov="ovDetail")
          TabOVHistorial(:ov="ovDetail")

</template>

<script>
import { io } from 'socket.io-client'
import { mapActions, mapGetters } from 'vuex'
import NotFound from '@/components/Shared/NotFound.vue'
import { backUrl, webSocketsUrl } from '../../../settings'
import OVActionsIndex from './OVActions/OVActionsIndex.vue'
import TabOVSolicitudData from './TabOVSolicitudData.vue'
import TabOVQuotationAndPayments from './TabOVQuotationAndPayments.vue'
import TabOVHistoryActions from './TabOVHistoryActions.vue'
import OVDetailClienteData from './OVDetailClienteData.vue'
import OVDetailRepuestosData from './OVDetailRepuestosData.vue'
import OVDetailCotizacionYBoletas from './OVDetailCotizacionYBoletas.vue'
import OVDetailBoletas from './OVDetailBoletas.vue'
import TabOVRepuestos from './TabOVRepuestos.vue'
import TabOVHistorial from './TabOVHistorial.vue'

export default {
  name: 'OVDetail',
  components: {
    OVActionsIndex,
    TabOVSolicitudData,
    TabOVQuotationAndPayments,
    TabOVHistoryActions,
    OVDetailClienteData,
    OVDetailRepuestosData,
    OVDetailCotizacionYBoletas,
    OVDetailBoletas,
    TabOVRepuestos,
    TabOVHistorial,
    NotFound,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      socket: null,
      loading: false,
      loadingPrint: false,
      ovNotFound: false,
      tabSelected: 0,
      breadcrumbs: [
        {
          text: 'Inicio',
          to: { path: '/' },
        },
        {
          text: 'Oportunidades de Venta',
          to: { path: '/oportunidad-venta' },
        },
        {
          text: `OV ${this.$route.params.ov_id}`,
          active: true,
        },
      ],
    }
  },
  computed: {
    ...mapGetters('OVStore', ['ovDetail']),
    isDesktop() {
      return this.windowWidth >= 1200
    },
  },
  watch: {
    '$route.params.ov_id': function () {
      this.breadcrumbs[2].text = `OV ${this.$route.params.ov_id}`
      this.fetchData()
    },
  },
  methods: {
    ...mapActions('OVStore', ['getOvDetail']),
    async fetchData() {
      this.loading = true
      try {
        const { ov_id } = this.$route.params
        const response = await this.getOvDetail(ov_id)
        if (response.status === 200) {
          console.log('detalles de ov obtenidos con éxito!')
        }
      } catch (e) {
        if (e?.response?.status === 404) {
          this.ovNotFound = true
          return
        }
      } finally {
        this.loading = false
      }
    },
    onTabChange(tab) {
      console.log('tab cambiada', tab)
    },
    onResize() {
      this.windowWidth = window.innerWidth
    },
    async printQuotation() {
      if (!this.ovDetail.cotizacion_pdf) {
        console.error('No se proporcionó un archivo PDF para imprimir.')
        return
      }

      try {
        this.loadingPrint = true

        const pdf = this.ovDetail.cotizacion_pdf
        const pdfUrl = this.cotizacionUrl(pdf)
        window.open(pdfUrl, '_blank')
      } catch (error) {
        this.$bvToast.toast(error, {
          variant: 'danger',
          title: 'Error al Imprimir',
          autoHideDelay: 5000,
        })
        console.error('Error al imprimir:', error)
      }
      this.loadingPrint = false
    },
    cotizacionUrl(pdf) {
      console.log(`${backUrl}${pdf}`)
      return `${backUrl}${pdf}`
    },
    getOvColor() {
      const colorMap = {
        'Pre Completado': { bg: '#d4edfa', fg: '#0096db' },
        Completado: { bg: '#d4edda', fg: '#155724' },
        'Cotización Enviada': { bg: '#cce5ff', fg: '#004085' },
        'Cotización por Revisar': { bg: '#fff3cd', fg: '#856404' },
        'Cotización Aceptada': { bg: '#d4edda', fg: '#155724' },
        'Cotización Aceptada por entregar': { bg: '#d1ecf1', fg: '#0c5460' },
        'Cotización Rechazada': { bg: '#f8d7da', fg: '#721c24' },
        'Oportunidad en Ejecución': { bg: '#cce5ff', fg: '#004085' },
        'Oportunidad en Espera de Partes': { bg: '#fff3cd', fg: '#856404' },
        'Oportunidad Aceptada': { bg: '#d4edda', fg: '#155724' },
        'Oportunidad Lista': { bg: '#56f000', fg: '#1a4700' },
        'Oportunidad Cerrada': { bg: '#74788d', fg: '#f8f9fe' },
        'Oportunidad Rechazada': { bg: '#f8d7da', fg: '#721c24' },
        'Oportunidad Cerrada Rechazada': { bg: '#721c24', fg: '#f8d7da' },
        'Solicitud en Excepción': { bg: '#f8d7da', fg: '#856404' },
      }
      const estado = this.ovDetail?.estado
      const color = colorMap[estado] || { bg: '#d4edfa', fg: '#0096db' }
      return `background-color: ${color.bg}; color: ${color.fg};`
    },
    initWebsockets() {
      this.socket = io(webSocketsUrl)
      this.socket.on('oportunidad_venta:updated', async ({ id }) => {
        const ovId = parseInt(this.$route.params.ov_id, 10)
        if (id === ovId) {
          // No refrescar si hay un modal abierto (evita StaleElementReferenceError en tests)
          const modalOpen = document.querySelector('.modal.show') !== null
          if (modalOpen) {
            console.log(
              'OV actualizada via WebSocket, pero hay modal abierto - esperando...'
            )
            return
          }
          console.log('OV actualizada via WebSocket, refrescando datos...')
          await this.fetchData()
        }
      })
    },
  },
  async created() {
    await this.fetchData()
    this.initWebsockets()
    window.addEventListener('resize', this.onResize)
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize)
    if (this.socket) {
      this.socket.disconnect()
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

::v-deep .back-arrow {
  color: $samtek-yellow;
  background-color: black;
  border-radius: 15px;
}
::v-deep .head-card {
  font-size: 0.9rem;
  color: #525252;
  font-weight: 600;
}
.ov-header-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.separator {
  color: #525252;
  font-weight: 400;
}
.ov-status {
  border-radius: 8px;
  min-width: 120px;
  height: 35px;
  font-weight: bold;
  font-size: 0.9rem;
  padding: 0 12px;
  display: inline-flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  // default fallback (overridden por inline style)
  background-color: #d4edfa;
  color: #0096db;
}
::v-deep .title-buttons {
  align-items: center;
}
::v-deep .action-print-buttons {
  display: flex;
  justify-content: end;
}
::v-deep .state-head {
  text-align: center;
  justify-content: start;
  display: flex;
  align-items: center;
  gap: 1rem;
}
@media (max-width: 767px) {
  ::v-deep .title-buttons {
    flex-direction: column;
    gap: 0.75rem;
    .state-head {
      width: 100%;
      justify-content: space-between;
    }
    .action-print-buttons {
      width: 100%;
      justify-content: space-between;
    }
  }
}
.card-ov-detail {
  border-radius: 16px !important;
  ::v-deep .card-body {
    padding: 24px !important;
  }
}
::v-deep .printer-btn {
  color: #23201c;
  background-color: #f5f6fa;
  border: solid #fece2f 1px;
  border-radius: 8px;
}
.printer-btn:hover {
  color: black;
  background-color: rgba(254, 206, 47, 0.1);
  border-color: #e5b823;
  box-shadow: none;
}
::v-deep .pills {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 5px;
  text-align: center;
}
::v-deep .nav-pills .nav-link.active,
.nav-pills {
  background-color: $samtek-yellow;
  color: #23201c;
  font-weight: 600;
  display: grid;
  text-align: center;
  display: grid !important;
}
::v-deep .nav-pills {
  grid-template-columns: repeat(3, 1fr) !important;
  display: grid !important;
  grid-auto-flow: column !important;
  color: #23201c !important;
  text-decoration: none !important;
  text-decoration-color: #23201c !important;
}
.ot-link {
  color: $sill-blue;
  cursor: pointer;
  text-decoration: none;
  font-weight: bolder;
}
.ot-link:hover {
  color: $sill-blue;
  text-decoration: underline;
}

.state {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 1rem;
  gap: 1.2rem;
  align-items: center;
}

.state-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #23201c;
  margin: 0;
}
.ov-link-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 0.9rem;
  gap: 12px;
  &--rechazada {
    background-color: #ff38381a;
    border: 1px solid #ff3838;
    color: #23201c;
  }
  &--origen {
    background-color: #dddde1;
    border: 1px solid #525252;
    color: #23201c;
  }
  &__content {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }
  &__icon {
    font-size: 1.1rem;
    flex-shrink: 0;
  }
  &--rechazada &__icon {
    color: #ff3838;
  }
  &--rechazada strong {
    color: #ff3838;
  }
  &--origen &__icon {
    color: #1d4ed8;
  }
  &__link {
    display: inline-flex;
    align-items: center;
    font-weight: 600;
    white-space: nowrap;
    text-decoration: underline;
  }
  &__link {
    color: #1d4ed8;
    text-decoration: none;
  }
  &__link:hover {
    text-decoration: underline;
  }
}
</style>
